<script setup>

</script>

<template>
<div class="rules-container">
    <div class="rules-header">
        <v-icon size="28" color="primary" class="mr-3">mdi-gavel</v-icon>
        <div>
            <h3 class="rules-title">Server Rules</h3>
            <p class="rules-subtitle">Please read and follow these rules to ensure a fair and enjoyable experience for everyone</p>
        </div>
    </div>

    <v-expansion-panels variant="accordion" class="mt-4">
        <v-expansion-panel title="Any nickname containing NSFW, and defamation are subject to renaming.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>First recidivism of that rule will lead to a deletion of the profile in fault.</li>
                    <li>Second recidivism of that rule will lead to a permanent ban of the account linked to the profile
                        at
                        fault.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Ramming is not allowed in our server, despite that it is part of racing there is limit to not cross.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>If there is video proofs that shows that someone ramming the player is subject to a temporary ban.</li>
                    <li>If there is recidivism after a temp ban, the faulty account will be definitively banned.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Everyone have to respect in-game language chats, if you select EN chat you must speak english.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>If there is any proofs of someone not respecting this, the player is subject to a temporary ban.</li>
                    <li>If there is recidivism after a temp ban, a longer temp ban will be initiated.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Any car liveries containing NSFW, defamation, political and religious sings are subject to a deletion.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>At the first recidivism the car in fault will be deleted and the player will be temporary banned.</li>
                    <li>At the second recidivism the account of the player will be definitively banned.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Cheating is prohibited, cheaters are subject to a temporary or definitive ban depending the gravity of cheats.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>If there is recidivism the account in fault will be definitively banned.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Any game modifications except the ones available in Discord and/or shader mods such as ReShade, SweetFX,
                ENB, WorldShader are prohibited.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>Depending the degree of the modifications of the game the player is subject to a temporary or definitive ban.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Every clashes via the public in-game chats are prohibited and subject to a kick of the players concerned.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>If there is recidivism the players concerned will be temporary banned.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel title="Begging for money is not allowed, if someone refuses to give money you have to respect his choice.">
            <v-expansion-panel-text>
                <ol type="A">
                    <li>If an user keep begging after being warned he will be temporarily banned.</li>
                </ol>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>

    <v-alert type="warning" variant="tonal" class="mt-4" icon="mdi-alert">
        <strong>Important:</strong> Violations of these rules may result in temporary or permanent bans depending on severity and recidivism.
    </v-alert>
</div>
</template>

<style scoped>
.rules-container {
    padding: 8px 0;
}

.rules-header {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    background: rgba(var(--v-theme-primary), 0.1);
    border-radius: 12px;
    border: 1px solid rgba(var(--v-theme-primary), 0.2);
}

.rules-title {
    margin: 0;
    font-size: 1.3em;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
}

.rules-subtitle {
    margin: 4px 0 0 0;
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.6);
}
</style>

<style>
.v-expansion-panel-text {
    padding: 16px !important;
}

.v-expansion-panel-text ol {
    margin: 8px 0;
    padding-left: 20px;
}

.v-expansion-panel-text li {
    margin: 8px 0;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.5;
}

.v-expansion-panel-title {
    margin: 0;
    font-weight: 500;
}

.v-expansion-panel {
    background: rgba(255, 255, 255, 0.03) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    margin-bottom: 8px !important;
    border-radius: 8px !important;
    overflow: hidden;
}

.v-expansion-panel:hover {
    background: rgba(255, 255, 255, 0.05) !important;
    border-color: rgba(var(--v-theme-primary), 0.3) !important;
}
</style>